import { render, staticRenderFns } from "./EmailStatusBadge.vue?vue&type=template&id=007ca2f4&"
import script from "./EmailStatusBadge.vue?vue&type=script&lang=js&"
export * from "./EmailStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports